// The clevis shackle mark as an inline SVG (from the brand kit's vector),
// with the body color configurable so it reads on dark surfaces — the raster
// favicons are ink-on-transparent and disappear on the ink sidebar.
export function ClevisMark({
  size = 28,
  body = "#213C4A",
  pin = "#DF8048",
  className,
}: {
  size?: number;
  body?: string;
  pin?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path fill={pin} d="M70 116h372v67H70z" />
      <rect x="42" y="113" width="48" height="72" rx="13" fill={pin} />
      <rect x="422" y="113" width="48" height="72" rx="13" fill={pin} />
      <path
        fill={body}
        d="M110 60 Q110 38 133 38 L168 38 Q190 38 190 60 L190 210 Q190 229 177 244 C152 276 159 334 192 363 C230 398 282 398 320 363 C353 333 360 276 335 244 Q322 229 322 210 L322 60 Q322 38 344 38 L379 38 Q402 38 402 60 L402 211 Q402 244 419 269 C471 360 396 474 290 482 C271 484 241 484 222 482 C116 474 41 360 93 269 Q110 244 110 211 Z"
      />
    </svg>
  );
}
